
import React from 'react';
import { CreditCard, Wallet, Link2, ShieldCheck, Activity } from 'lucide-react';
import { Card } from './SharedComponents';

export const SettingsGateways = ({ isSuper }: { isSuper: boolean }) => {
  // As chaves são lidas via process.env para segurança
  const stripeSecret = typeof process !== 'undefined' ? process.env.STRIPE_SECRET_KEY : null;
  const mpToken = typeof process !== 'undefined' ? process.env.MERCADO_PAGO_TOKEN : null;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 animate-in slide-in-from-bottom-2">
      <div className="lg:col-span-2 space-y-6">
        <Card className={`${isSuper ? 'bg-[#1e293b] border-white/5 p-10' : 'bg-white p-10'} rounded-[40px] shadow-2xl`}>
          <h3 className={`text-2xl font-black uppercase tracking-tight mb-8 flex items-center gap-3 ${isSuper ? 'text-white' : 'text-secondary'}`}>
            <CreditCard size={32} className="text-primary" /> Gateways de Pagamento
          </h3>

          <div className="space-y-12">
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-[#635bff] rounded-2xl flex items-center justify-center text-white"><CreditCard size={28} /></div>
                  <div>
                    <span className={`text-lg font-black uppercase ${isSuper ? 'text-white' : 'text-secondary'}`}>Stripe Connect</span>
                    <p className="text-[10px] text-primary font-black uppercase tracking-widest">SaaS Billing Engine</p>
                  </div>
                </div>
                <BadgeStatus active={!!stripeSecret} />
              </div>
              <div className="bg-black/20 p-6 rounded-3xl border border-white/5">
                 <label className="text-[9px] font-black text-white/30 uppercase tracking-widest">Secret Key (.env)</label>
                 <div className="flex items-center justify-between mt-1">
                    <span className="font-mono text-xs text-white/50">{stripeSecret ? 'sk_live_••••••••••••••••' : 'Chave não configurada'}</span>
                    <button className="text-primary text-[10px] font-black uppercase hover:underline">Alterar no Core</button>
                 </div>
              </div>
            </div>

            <div className="space-y-6 pt-8 border-t border-white/5">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-[#009ee3] rounded-2xl flex items-center justify-center text-white"><Wallet size={28} /></div>
                  <div>
                    <span className={`text-lg font-black uppercase ${isSuper ? 'text-white' : 'text-secondary'}`}>Mercado Pago</span>
                    <p className="text-[10px] text-primary font-black uppercase tracking-widest">Latam Payments</p>
                  </div>
                </div>
                <BadgeStatus active={!!mpToken} />
              </div>
              <div className="bg-black/20 p-6 rounded-3xl border border-white/5">
                 <label className="text-[9px] font-black text-white/30 uppercase tracking-widest">Access Token (.env)</label>
                 <div className="flex items-center justify-between mt-1">
                    <span className="font-mono text-xs text-white/50">{mpToken ? 'APP_USR-••••••••••••••••' : 'Aguardando Configuração'}</span>
                    <button className="text-primary text-[10px] font-black uppercase hover:underline">Configurar</button>
                 </div>
              </div>
            </div>
          </div>
        </Card>
      </div>

      <div className="space-y-6">
        <Card className="bg-[#111827] p-8 border-white/5 shadow-2xl rounded-[40px]">
           <h3 className="text-sm font-black text-primary uppercase tracking-widest mb-6 flex items-center gap-2">
              <Activity size={16} /> Webhooks SaaS
           </h3>
           <div className="space-y-3">
              <div className="flex items-center justify-between p-3 bg-white/5 rounded-xl border border-white/5">
                 <span className="text-[9px] font-mono text-white/40">stripe_sub_sync</span>
                 <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></div>
              </div>
              <div className="flex items-center justify-between p-3 bg-white/5 rounded-xl border border-white/5">
                 <span className="text-[9px] font-mono text-white/40">mp_pix_notify</span>
                 <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></div>
              </div>
           </div>
           <div className="mt-8 pt-6 border-t border-white/5">
              <p className="text-[9px] text-white/20 font-bold uppercase tracking-widest leading-relaxed text-center">
                 A integridade financeira é mantida através de webhooks sincronizados a cada 10 min.
              </p>
           </div>
        </Card>
      </div>
    </div>
  );
};

const BadgeStatus = ({ active }: { active: boolean }) => (
  <div className="flex items-center gap-2">
    <div className={`w-2 h-2 rounded-full ${active ? 'bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.5)]' : 'bg-red-500'}`}></div>
    <span className={`text-[10px] font-black uppercase ${active ? 'text-green-400' : 'text-red-500'}`}>{active ? 'Sincronizado' : 'Offline'}</span>
  </div>
);
